window.fbAsyncInit = function () {
    FB.init({
        appId: "1633911916914982", //ADLOADER
        autoLogAppEvents: true,
        xfbml: true,
        version: "v24.0",
    });
    FB.AppEvents.logPageView();
};

(function (d, s, id) {
    var js,
        fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
        return;
    }
    js = d.createElement(s);
    js.id = id;
    js.src = "//connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "facebook-jssdk");
